import { PlayHistoryReport } from "../play-model"
import "./history-report-summary.less"
import PercentageListItem from "../components/percentage-list-item"

export default function HistoryReportSummary(props: {
  report: PlayHistoryReport
  expandable: boolean
}) {
  const { report, stats } = props.report
  const { expandable } = props

  return (
    <PercentageListItem
      key={report.id}
      title={report.lessonName || ""}
      successRate={stats.successRate}
      routeTo={expandable ? `/history/${report.id}` : undefined}
    />
  )
}
